interface GetProductLinkLabelParams {
	productId: string
	productName: string
	selectedColorLabel: string
	lookId?: string
}
export function getProductLinkLabel({
	productId,
	productName,
	selectedColorLabel,
	lookId,
}: GetProductLinkLabelParams) {
	let productRef = productId
	if (lookId) {
		productRef = `${productRef}-${lookId}`
	}
	return `${productName}, ${selectedColorLabel}. Ref: ${productRef}.`
}
